import { gql } from '@apollo/client'

export const CREATE_TEMPLATE = gql`
  mutation createTemplate($input: CreateTemplateInput!) {
    data: createTemplate(input: $input) {
      id
    }
  }
`
